define( function() {

"use strict";

function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};

return nodeName;

} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/core/nodeName.js
 ** module id = 77
 ** module chunks = 0
 **/